import React, { createContext, useState, useContext, useEffect } from 'react';
import { auth as authAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');

    if (token && userData) {
      const parsedUser = JSON.parse(userData);

      // Ha hiányoznak az új profil mezők, frissítjük a profilt a szerverről
      const hasNewFields = 'profileImage' in parsedUser && 'nickname' in parsedUser && 'isPublic' in parsedUser;

      if (!parsedUser.role || !hasNewFields) {
        console.log('🔄 Profil mezők hiányoznak, frissítés a szerverről...');
        authAPI.getProfile()
          .then(response => {
            const fullUserData = response.data;
            localStorage.setItem('user', JSON.stringify(fullUserData));
            setUser(fullUserData);
            console.log('✅ Profil frissítve:', fullUserData);
          })
          .catch(error => {
            console.error('❌ Profil frissítés sikertelen:', error);
            setUser(parsedUser); // Régi adatokkal tovább
          });
      } else {
        setUser(parsedUser);
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const response = await authAPI.login({ email, password });
    const { token, ...userData } = response.data;

    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);

    return response.data;
  };

  const register = async (name, email, password) => {
    const response = await authAPI.register({ name, email, password });

    // Email verification needed - DON'T auto-login
    if (response.data.requiresVerification) {
      return response.data;
    }

    // Backward compatibility - if no verification required (shouldn't happen with new system)
    const { token, ...userData } = response.data;
    if (token) {
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
    }

    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const updateUser = (userData) => {
    // If token is included, update it separately
    if (userData.token) {
      const { token, ...userDataWithoutToken } = userData;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(userDataWithoutToken));
      setUser(userDataWithoutToken);
    } else {
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, updateUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
